import type { ActiveGamesState, Model } from '../../types';

import effects from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';

export const defaultState = {
  games: []
} satisfies ActiveGamesState;

interface ActiveGamesModel extends Model<ActiveGamesState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
  effects: typeof effects;
}

const activeTable: ActiveGamesModel = {
  state: defaultState,
  reducers,
  selectors,
  effects
};

export const ACTIVE_GAMES_LOCAL_STORAGE_KEY = 'currentOpenActiveGames';

export default activeTable;
